const plans = {
  "plans.hero.badge": "أسعار بسيطة وشفافة",
  "plans.hero.title.line1": "اختر",
  "plans.hero.title.line2": "خطتك المثالية",
  "plans.hero.subtitle": "طور أتمتة الذكاء الاصطناعي مع الخطة المناسبة. جميع الخطط تشمل دورة 30 يوماً مع وصول كامل للميزات الأساسية.",
  "plans.name.basic": "أساسية",
  "plans.name.pro": "برو",
  "plans.name.enterprise": "متقدمة",
  "plans.description.basic": "مثالية للأفراد اللي بيبدأوا في أتمتة الذكاء الاصطناعي",
  "plans.description.pro": "مناسبة للشركات والفرق المتنامية",
  "plans.description.enterprise": "للعمليات واسعة النطاق بأقصى قوة",
  "plans.badge.popular": "الأكثر شيوعاً",
  "plans.price.perDays": "يوماً",
  "plans.getStarted": "ابدأ مع",
  "plans.compare.badge": "مقارنة الخطط",
  "plans.compare.title": "تفصيل كامل للميزات",
  "plans.compare.subtitle": "اعرف بالضبط ما تحصل عليه مع كل خطة واختر الأنسب لاحتياجاتك.",
  "plans.compare.feature": "الميزة",
  "plans.compare.basic": "أساسية",
  "plans.compare.pro": "برو",
  "plans.compare.enterprise": "متقدمة",
  "plans.feature.messages": "الرسائل / شهرياً",
  "plans.feature.tokens": "الرموز / شهرياً",
  "plans.feature.sessions": "جلسات واتساب",
  "plans.feature.automation": "قواعد الأتمتة",
  "plans.feature.analytics": "سجل التحليلات",
  "plans.feature.bulk": "الرسائل الجماعية",
  "plans.feature.csv": "استيراد المنتجات",
  "plans.feature.api": "الوصول للـ API",
  "plans.feature.support": "الدعم",
  "plans.feature.textResponse": "الرد على النصوص",
  "plans.feature.voiceResponse": "الرد على الرسائل الصوتية",
  "plans.feature.imageResponse": "الرد على الصور",
  "plans.feature.documentResponse": "الرد على المستندات",
  "plans.value.unlimited": "غير محدود",
  "plans.value.basic": "أساسي",
  "plans.value.advanced": "متقدم",
  "plans.value.fullSuite": "الحزمة الكاملة",
  "plans.value.days7": "7 أيام",
  "plans.value.days30": "30 يوماً",
  "plans.value.unlimitedDays": "غير محدود",
  "plans.value.email": "بريد إلكتروني",
  "plans.value.priority": "أولوية",
  "plans.value.dedicated": "مخصص",
  "plans.faq.badge": "لديك أسئلة؟",
  "plans.faq.title": "الأسئلة الشائعة",
  "plans.faq.q1": "هل يمكنني تغيير الخطط في أي وقت؟",
  "plans.faq.a1": "بالتأكيد. يمكنك ترقية أو تخفيض خطتك في أي وقت خلال دورة الفوترة. التغييرات تسري فوراً.",
  "plans.faq.q2": "ماذا يحدث عند الوصول للحد الأقصى للرسائل أو الرموز؟",
  "plans.faq.a2": "ستتلقى إشعاراً عند الاقتراب من الحد. تستمر خدمتك ولكن يتم إيقاف الاستخدام الإضافي مؤقتاً حتى الدورة التالية أو ترقية الخطة.",
  "plans.faq.q3": "هل تنتقل الرسائل غير المستخدمة للشهر التالي؟",
  "plans.faq.a3": "لا، كل دورة 30 يوماً تبدأ بحصة كاملة جديدة. استخدمها أو ستفقدها — لذا استفد من كل دورة لأقصى حد.",
  "plans.faq.q4": "هل توجد نسخة تجريبية مجانية؟",
  "plans.faq.a4": "لا نقدم نسخة تجريبية مجانية حالياً، لكن الخطة الأساسية مصممة لتكون نقطة انطلاق ميسورة مع طاقة كافية للبدء.",
  "plans.finalCta.title": "مستعد للبدء؟",
  "plans.finalCta.subtitle": "اختر الخطة التي تناسب احتياجاتك وابدأ أتمتة اتصالات واتساب اليوم. لا يتطلب تسجيل دخول — فقط ادفع وابدأ.",
  "plans.finalCta.button": "اختر خطتك",
  "plans.payment.title": "إتمام الدفع",
  "plans.payment.total": "الإجمالي",
  "plans.payment.pay": "ادفع الآن",
  "plans.payment.cancel": "إلغاء",
  "plans.payment.youSelected": "لقد اخترت",
  "plans.payment.plan": "خطة",
  "plans.payment.perDays": "/ {{duration}} يوماً",
  "plans.payment.firstName": "الاسم الأول",
  "plans.payment.firstNamePlaceholder": "علي",
  "plans.payment.lastName": "الاسم الأخير",
  "plans.payment.lastNamePlaceholder": "حسن",
  "plans.payment.email": "البريد الإلكتروني",
  "plans.payment.emailPlaceholder": "ali@example.com",
  "plans.payment.phone": "رقم الهاتف",
  "plans.payment.processing": "جاري المعالجة...",
  "plans.payment.payButton": "ادفع {{price}}",
  "plans.payment.digitsLeft": "{{count}} متبقي",
  "plans.payment.enterMoreDigits": "أدخل {{count}} رقم إضافي",
  "plans.payment.enterMoreDigitsPlural": "أدخل {{count}} أرقام إضافية",
  "plans.payment.err.firstNameRequired": "الاسم الأول مطلوب",
  "plans.payment.err.lastNameRequired": "الاسم الأخير مطلوب",
  "plans.payment.err.emailRequired": "البريد الإلكتروني مطلوب",
  "plans.payment.err.emailInvalid": "أدخل بريداً إلكترونياً صحيحاً",
  "plans.payment.err.phoneRequired": "رقم الهاتف مطلوب",
  "plans.payment.err.phoneDigitsOnly": "يجب أن يحتوي رقم الهاتف على أرقام فقط",
  "plans.payment.err.phoneLength": "يجب أن يكون {{digits}} رقماً بالضبط",
  "plans.messages": "الرسائل",
  "plans.tokens": "الرموز",
  "plans.cachedNotice": "جارٍ عرض الأسعار المخزنة مؤقتاً",
  "plans.priceFormat": "{{amount}} ج.م",
};

export default plans;